import React from "react";

export default function Loader({ className }) {
  return (
    <div
      className={`d-flex align-items-center justify-content-center ${className}`}
    >
      <div className="spinner-grow text-secondary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
